import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { useSelector } from 'react-redux';
import Fade from '@material-ui/core/Fade';
import LoginProfile from './components/profileAndLogin/LoginProfile';
import ForgottenPasswordContaner from './components/profileAndLogin/ForgottenPasswordContaner';
import ProfileMain from './components/profileAndLogin/ProfileMain';
import ProfileMyData from './components/profileAndLogin/ProfileMyData';
import ProfileMyDataEdit from './components/profileAndLogin/ProfileMyDataEdit';
import ProfileChangeEmail from './components/profileAndLogin/ProfileChangeEmail';
import ProfileAddresses from './components/profileAndLogin/ProfileAddresses';
import ProfilePayCards from './components/profileAndLogin/ProfilePayCards';


const Profile = () => {

  const history = useHistory();

  const auth = useSelector(state => state.auth);
  const {loginToken} = auth || {};

  const liabilityStep = useSelector(state => state.liabilityStep);
  const {goToLiability} = liabilityStep;
  
  const [step, setStep] = useState(loginToken ? 3 : 1);
  const [stepBack, setStepBack] = useState(null);
  const [showFade, setShowFade] = useState(true);

  // useEffect(()=>{
  //   if(loginToken) {
  //     setStep(3)
  //   } else {
  //     setStep(1)
  //   }

  // },[loginToken])

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [step]);

  useEffect(() => {
    if(!loginToken) setStep(1);
  }, [loginToken]);

  const onBack = (toStep) => {
      toStep = stepBack ? stepBack : toStep;

      if(!toStep) {
        return liabilityStep?.step ? history.goBack() : null;
      }

      setShowFade(false);

      setTimeout(() => {
        setStep(toStep);
        setStepBack(null);
        setShowFade(true);
      }, 0);
  }

  const onForward = (toStep, backTo) => {
      backTo ? setStepBack(backTo) : setStepBack(false);
      setShowFade(false);

      if (goToLiability && toStep === 3) {
        return history.goBack();
      }

      setTimeout(() => {
        setStep(toStep);
        setShowFade(true);
      }, 0);
      
  }

  const renderStepScreen = () => {
      switch (step) {
          case 1:
            return <LoginProfile onBack={onBack} onForward={onForward} />;
          case 2:
            return <ForgottenPasswordContaner onBack={onBack} onForward={onForward} />;
          case 3:
            return <ProfileMain onBack={onBack} onForward={onForward} />;
          case 4:
            return <ProfileMyData onBack={onBack} onForward={onForward} />;
          case 5:
            return <ProfileMyDataEdit onBack={onBack} onForward={onForward} />;
          case 6:
            return <ProfileChangeEmail onBack={onBack} onForward={onForward} />;
          case 7:
            return <ProfileAddresses onBack={onBack} onForward={onForward} />;
          case 8:
            return <ProfilePayCards onBack={onBack} onForward={onForward} />;

          default:
            return <div></div>;
      }
  }

  return (
      <div style={{position: 'realtive'}}>
          <Fade in={showFade} timeout={{enter: 600, exit: 0}} disableStrictModeCompat={true}>
            {renderStepScreen()}
          </Fade>
      </div>
  )
}

export default Profile;